var map = {
	"./bookmark_a.svg": 65,
	"./camcorder_a.svg": 122,
	"./checkbox_a.svg": 36,
	"./comment_a.svg": 130,
	"./compass_a.svg": 97,
	"./creditCard_a.svg": 132,
	"./foldercamera_a.svg": 136,
	"./free_a.svg": 137,
	"./gallery_a.svg": 78,
	"./heart_a.svg": 51,
	"./home_a.svg": 99,
	"./msg_a.svg": 100,
	"./night_a.svg": 101,
	"./notifications_a.svg": 81,
	"./paid_a.svg": 102,
	"./photo_a.svg": 148,
	"./plus_a.svg": 52,
	"./profile_a.svg": 104,
	"./search_a.svg": 151,
	"./setting_a.svg": 152,
	"./star_a.svg": 44,
	"./sun_a.svg": 106,
	"./tick_a.svg": 83,
	"./tip_a.svg": 155,
	"./transaction_a.svg": 158,
	"./trash_a.svg": 45,
	"./upload_a.svg": 55,
	"./url_a.svg": 85,
	"./verified_a.svg": 161
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37;